import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeunderscore',
    standalone: false
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    if (!value)  {
      return null;
    }

    return value.replace(/_/g, ' ');
  }
}
